module.exports = __webpack_public_path__ + "img/regis.e54c3670.png";